import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@shared/model/api-response.model';
import { BellNotificationModel } from '@typeDefs/home/responses/home';

@Injectable({
  providedIn: 'root',
})
export class BellNotficationApiService {
  private readonly http = inject(HttpClient);

  getBellNotifications(userKeyID: number): Observable<BellNotificationModel[]> {
    return this.http.get<BellNotificationModel[]>('/Home/GetBellNotifications?userKeyID=' + userKeyID);
  }

  dismissBellNotification(userKeyID: number, bellNotificationID: bigint): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Home/DismissBellNotification', {
      userKeyID: userKeyID,
      bellNotificationID: bellNotificationID,
    });
  }
}
